<template>
  <div class="home">
    <ProductStockCloseList v-show="listView" @newClose="onClickNewFromList" @editClose="onClickEditFromList" :scroll="corY" :idx="idx" ref="refreshList"/>
    <ProductStockCloseForm v-show="formView" :close="close" @backClicked="onBackChild" />
  </div>
</template>

<script>
// @ is an alias to /src
import ProductStockCloseList from '@/components/product/ProductStockCloseList.vue'
import ProductStockCloseForm from '@/components/product/ProductStockCloseForm.vue'
import { mapState } from 'vuex'

export default {
  name: 'ProductStockClose',
  components: {
    ProductStockCloseList,
    ProductStockCloseForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      idx: null,
      listView: true,
      formView: false,
      close: {
        id: null,
        close_no: null,
        close_date: null,
        notes: null,
        company_no: null
      }
    }
  },
  methods: {
    resetIndex () {
      this.idx = null
    },
    onClickEditFromList: function (value) {
      var x = 0
      var y = window.scrollY || window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      console.log(x + '|' + y)
      this.listView = false
      this.formView = true
      this.idx = value.index
      this.close = value
      console.log(this.close)
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.close = {
        id: null,
        close_no: null,
        close_date: null,
        notes: null,
        company_no: null
      }
    },
    onBackChild () {
      this.listView = true
      this.formView = false
      this.close = {
        id: null,
        close_no: null,
        close_date: null,
        notes: null,
        company_no: null
      }
      this.$store.dispatch('getCompanyList')
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser
    })
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
  }
}
</script>
